/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Marketplace_Seo_License_Table_Col_ScopeInputs */

const es_marketplace_seo_license_table_col_scope = /** @type {(inputs: Marketplace_Seo_License_Table_Col_ScopeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alcance`)
};

const gl_marketplace_seo_license_table_col_scope = /** @type {(inputs: Marketplace_Seo_License_Table_Col_ScopeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alcance`)
};

const en_marketplace_seo_license_table_col_scope = /** @type {(inputs: Marketplace_Seo_License_Table_Col_ScopeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Scope`)
};

/**
* | output |
* | --- |
* | "Scope" |
*
* @param {Marketplace_Seo_License_Table_Col_ScopeInputs} inputs
* @param {{ locale?: "es" | "gl" | "en" }} options
* @returns {LocalizedString}
*/
export const marketplace_seo_license_table_col_scope = /** @type {((inputs?: Marketplace_Seo_License_Table_Col_ScopeInputs, options?: { locale?: "es" | "gl" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Marketplace_Seo_License_Table_Col_ScopeInputs, { locale?: "es" | "gl" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "gl") return gl_marketplace_seo_license_table_col_scope(inputs)
	if (locale === "en") return en_marketplace_seo_license_table_col_scope(inputs)
	return es_marketplace_seo_license_table_col_scope(inputs)
});